import { render, staticRenderFns } from "./G-1-1b-7__SupportEdit_B2C_Anti-forgery.vue?vue&type=template&id=50decfbc&"
import script from "./G-1-1b-7__SupportEdit_B2C_Anti-forgery.vue?vue&type=script&lang=js&"
export * from "./G-1-1b-7__SupportEdit_B2C_Anti-forgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
